import React from 'react'

import { getBucketInfo } from './service/store.service'
import { StoreItemList } from './components/list'
import { StorageItemFilter } from './components/filter'
import { describeBytes } from 'util/index'

const Storage: React.FC = () => {
  const { data } = getBucketInfo()

  return (
    <div className="row panel bordered">
      <div className="row storage-container">
        <div className="row padding-24">
          <p className="grow" style={{ fontSize: 18 }}>Meus Arquivos</p>
          <div className="row flex justify-end" style={{ gap: 16 }}>
            <span style={{ display: 'flex', flexDirection: 'column' }}>
              <b>Espaço</b>
              {describeBytes(data?.quota)}
            </span>
            <span style={{ display: 'flex', flexDirection: 'column' }}>
              <b>Em uso</b>
              {describeBytes(data?.used)} / {data?.percentage ? `${data.percentage}%` : '...'}
            </span>
          </div>
        </div>

        <div className="row padding-24">
          <StorageItemFilter />
          <StoreItemList />
        </div>
      </div>
    </div>
  )
}

export default Storage
